import zone from "@/api/driver/zone";

import { baseState, baseMutations } from "@/store/mixins";
import { isEmpty } from "lodash";
export const state = {
    ...baseState
};

export const getters = {};

export const mutations = {
    ...baseMutations
};

export const actions = {
           fetch(context, attributes = {}) {
               let params = Object.assign(
                   {
                       page: context.state.pagination.page,
                       perPage: context.state.pagination.perPage,
                       filter: {
                           is_stock_order: context.state.is_stock_order
                               ? true
                               : undefined,
                           search: context.state.search
                       }
                   },
                   attributes
               );
               return zone.get({ params }).then(response => {
                   context.commit("RECEIVE_RESOURCES", response);
                   return Promise.resolve(response);
               });
           },
           store(context, data) {
               return zone.store(data);
           },

           shopList(context, data) {
               return zone.shopList(data);
           },

           getDrivers(context, data) {
               return zone.getDrivers(data);
           },

           shopTypeList(context, data) {
               return zone.shopTypeList(data);
           },

           async find(context, id) {
               if (isEmpty(context.state.edit_data)) {
                   let response = await zone.find(id);
                   context.commit("SET_EDIT_DATA", response.data);
               }
           },

           update(context, { id, data }) {
               return zone.update(id, data);
           },

           assignDriver(context, data) {
               return zone.assignDriver(data);
           },
           destroy(context, id) {
               return zone.destroy(id);
           }
       };
